export default "__VITE_ASSET__BYGuffVX__"